<template>
	<b-modal class="modal-lg" id="ModalClearDeleteEmailNotification" ref="clearDeleteEmailNotification-modal" :title="clearEmailNotificationModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop @hide="resetModal('main')">
		<template slot="modal-header" slot-scope="{ close }">
			<h5 class="modal-title text-light">{{ t(clearEmailNotificationModal.modalData.title, clearEmailNotificationModal.modalData.title) }}</h5>
			<button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">x</span></button>
		</template>
		<template slot="default">
			<div class="modal-body-log">
				<div v-if="clearEmailNotificationModal.modalData.component == 'clearNotification'">
					<span>{{ t('clearNotificationQuestion', 'clearNotificationQuestion') }} </span><span class="font-weight-bold"> {{clearEmailNotificationModal.modalData.string_id}}</span>?
				</div>
				<div v-else>
					<span>{{ t('deleteNotificationQuestion', 'deleteNotificationQuestion') }} </span><span class="font-weight-bold"> {{clearEmailNotificationModal.modalData.string_id}}</span>?
				</div>
			</div>
		</template>
		<template slot="modal-footer" slot-scope="{ close }">
			<div v-if="clearEmailNotificationModal.modalData.component == 'clearNotification'">
				<button type="button" class="btn btn-secondary mr-1" @click="close()">Cancel</button>
				<button v-if="!buttonIsBusy" type="button" class="btn btn-primary" @click="clearEmailNotification()">{{ t('clearNotificationBtn', 'clearNotificationBtn') }}</button>							
				<b-button v-else variant="primary" disabled>
					<b-spinner small type="grow"></b-spinner>
					{{ t('clearNotificationBtn', 'clearNotificationBtn') }}
				</b-button>
			</div>
			<div v-else>
				<button type="button" class="btn btn-secondary mr-1" @click="close()">Cancel</button>
				<button v-if="!buttonIsBusy" type="button" class="btn btn-primary" @click="deleteEmailNotification()">{{ t('deleteNotificationBtn', 'deleteNotificationBtn') }}</button>							
				<b-button v-else variant="primary" disabled>
					<b-spinner small type="grow"></b-spinner>
					{{ t('deleteNotificationBtn', 'deleteNotificationBtn') }}
				</b-button>
			</div>
		</template>	
	</b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'ModalClearDeleteEmailNotification',
	data() {
		return {
			buttonIsBusy: false,
			clearEmailNotificationModal: null
		}
	},
  inject: [
    'resetModal'
  ],
  components:{
    
  },	
	created() {
		this.clearEmailNotificationModal = this.$attrs.modal
	},
	methods: {
		clearEmailNotification() {
			this.buttonIsBusy = true
			this.$store.dispatch('emailNotificationsStore/clearEmailNotification', {
				stringId: this.clearEmailNotificationModal.modalData.string_id,
				languageCode: this.clearEmailNotificationModal.modalData.languageCode
			}).then(() => {
				this.buttonIsBusy = false
				this.$refs['clearDeleteEmailNotification-modal'].hide()
				this.$parent.getEmailNotificationTranslationList()
			})
		},
		deleteEmailNotification() {
			this.buttonIsBusy = true
			this.$store.dispatch('emailNotificationsStore/deleteEmailNotification', {
				stringId: this.clearEmailNotificationModal.modalData.string_id
			}).then(() => {
				this.buttonIsBusy = false
				this.$refs['clearDeleteEmailNotification-modal'].hide()
				this.$parent.getEmailNotificationTranslationList()
			})
		}		
	}
}
</script>

<style scoped>

</style>